// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 24 18", width: "24", height: "18" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M800,1950 C793.373,1950 788,1957.5 788,1959 C788,1960.5 793.373,1968 800,1968 C806.627,1968 812,1960.5 812,1959 C812,1957.5 806.627,1950 800,1950 Z M800,1963 C797.791,1963 796,1961.209 796,1959 C796,1956.791 797.791,1955 800,1955 C802.209,1955 804,1956.791 804,1959 C804,1961.209 802.209,1963 800,1963 Z", transform: "translate(-788 -1950)" })))));
};
Icon.displayName = 'Eye24x24';
export default Icon;
//# sourceMappingURL=Eye24x24.js.map